module.exports = __webpack_public_path__ + "static/unicorn-rainbow-1a32257127ada74f98bdc4e21e0563c8.jpg";